import { api } from '@/src/shared/lib/api'

export async function videoProfilesSimilarGet<ApiResponse>(userId: number) {
  const url = api.appURL('video/profiles/similar')
  url.searchParams.set('userId', userId.toString())
  const response = await api.get<ApiResponse>(url)
  return api.parseRespone<ApiResponse>(response)
}
